import axios from './index'

class policy {
    //获取订单列表
    static getPolicy(params) {
        return axios.get('/app-admin/policy-standard/policy-base', {params: params})
    }

    //编辑渠道
    static addAndEditPolicy(params) {
        return axios.put(`/app-admin/policy-standard/policy-base`, params)
    }

    static getPolicyLevel(params) {
        return axios.get('/app-admin/policy-standard/policy-hotel-level-base', {params: params})
    }

    static getLevelList(params) {
        return axios.get('/app-admin/level/list', {params: params})
    }

    static addPolicyLevel(params) {
        return axios.post(`/app-admin/policy-standard/policy-hotel-level-base`, params)
    }

    static getPolicyHotelRule(params) {
        return axios.get('/app-admin/policy-standard/policy-hotel-rule', {params: params})
    }

    static createPolicyHotelRule(params) {
        return axios.post(`/app-admin/policy-standard/policy-hotel-rule`, params)
    }


    static updatePolicyHotelRule(params) {
        return axios.put(`/app-admin/policy-standard/policy-hotel-rule-info`, params)
    }

    static deletePolicyHotelRule(params) {
        return axios.delete(`/app-admin/policy-standard/policy-hotel-rule-info`, {params: params})
    }


    static getCityChildNode(areaCode) {
        return axios.get('/app-admin/policy-standard/policy-city/' + areaCode + '/child-node')
    }

    static getPolicyCity(params) {
        return axios.get('/app-admin/policy-standard/policy-city', {params: params})
    }

    static getPolicyTicketRule(params) {
        return axios.get('/app-admin/policy-standard/policy-ticket-rule', {params: params})
    }

    static addPolicyTicketRule(params) {
        return axios.post(`/app-admin/policy-standard/policy-ticket-rule`, params)
    }

    static deletePolicyTicketRule(params) {
        return axios.delete(`/app-admin/policy-standard/policy-ticket-rule`, {params: params})
    }

    static putPolicyTicketRuleList(params) {
        return axios.put(`/app-admin/policy-standard/policy-ticket-rule-list-info`, params)
    }

    static addPolicyTicketRuleList(params) {
        return axios.post(`/app-admin/policy-standard/policy-ticket-rule-list-info`, params)
    }



    static getPolicyTrainSeats(params) {
        return axios.get(`/app-admin/policy-standard/policy-train-seats`, {params: params})
    }

    static getPolicyTrainRule(params) {
        return axios.get(`/app-admin/policy-standard/policy-train-rule`, {params: params})
    }

    static addAndEditPolicyTrainRule(params) {
        return axios.post(`/app-admin/policy-standard/policy-train-rule`, params)
    }

    static addAndEditPolicyTrainRuleInfo(params) {
        return axios.post(`/app-admin/policy-standard/policy-train-rule-list-info`, params)
    }

    static putPolicyTrainRuleList(params) {
        return axios.put(`/app-admin/policy-standard/policy-train-rule-list-info`, params)
    }



    static deletePolicyTrainRule(params) {
        return axios.delete(`/app-admin/policy-standard/policy-train-rule`, {params: params})
    }


}

export default policy;
